enum EStatusAPIKeys
{
	orderStatuses = 'orderstatuses',
	deliveryStatuses = 'deliverystatuses',
	productStatuses = 'productstatuses',
	invoiceStatuses = 'salesinvoicestatuses',

}

export default EStatusAPIKeys;